module.exports = __webpack_public_path__ + "img/ofm-logo-1x.9ea33eb8.png";